import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';

const guards = [roleGuard('ADMIN_MASTER'), permissionGuard('HOME_SCREEN$READ')];

const listLoader = () =>
  import(
    './components/smart/hf-list-page/hf-list-page.component'
  ).then((m) => m.HfListPageComponent);

const detailLoader = () =>
  import(
    './components/smart/homepage-builder-hf-detail-page/homepage-builder-hf-detail-page.component'
  ).then((m) => m.HomepageBuilderHfDetailPageComponent);

export const homepageBuilderHeaderFooterRoutes: Routes = [
  {
    path: 'homepage-master/home/header-footer',
    data: { title: 'Homepage Header & Footer' },
    canActivate: guards,
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: listLoader,
        children: [
          {
            path: ':id',
            loadComponent: detailLoader,
            data: { title: 'Homepage Header & Footer Detail' },
          },
        ],
      },
    ],
  },
];
